/**
 * Customer Schemas
 *
 * Zod validation schemas for customer-related operations
 */

import z from "zod";

import { Fields } from "@/components/_Fields";
import { MESSAGE, REGEX } from "@/lib/zod";
import { isValidCPFOrCNPJ } from "@/lib/zod/zod.utils";

/**
 * Schema for creating/editing a customer
 * Includes validation for CPF/CNPJ, address fields, and contacts
 */
export const editCustomerArgsSchema = z.object({
  id: z.number().optional(),
  code: z.string().min(1, MESSAGE.GLOBAL.REQUIRED_FIELD("Código")),
  name: z.string().min(1, MESSAGE.GLOBAL.REQUIRED_FIELD("Nome Fantasia")),
  company: z.string().min(1, MESSAGE.GLOBAL.REQUIRED_FIELD("Razão Social")),
  stateRegistration: z.string().optional(),
  //TODO - Por algum motivo CPF também é tratado como cnpj na API lembrar de incluir cpf para pf e cnpj para pj
  cnpj: z.string().min(1, MESSAGE.GLOBAL.REQUIRED_FIELD("Cnpj/Cpf")).regex(REGEX.CPF_OR_CNPJ, MESSAGE.CPF_OR_CNPJ.INVALID).refine(isValidCPFOrCNPJ, {
    message: MESSAGE.CPF_OR_CNPJ.INVALID
  }),
  uf: z.string(MESSAGE.GLOBAL.REQUIRED_FIELD("Estado")).min(1, MESSAGE.GLOBAL.REQUIRED_FIELD("Estado")),
  street: z.string().optional(),
  number: z.string().optional(),
  complement: z.string().optional(),
  city: z.string().min(1, MESSAGE.GLOBAL.REQUIRED_FIELD("Cidade")),
  district: z.string().min(1, MESSAGE.GLOBAL.REQUIRED_FIELD("Bairro")),
  zipCode: z.string().min(1, MESSAGE.GLOBAL.REQUIRED_FIELD("Cep")).regex(REGEX.CEP, MESSAGE.CEP.INVALID),
  contact: z.array(Fields.Contacts.$schema.extend({ id: z.number().optional() })).optional(),
  _company: z.object({ id: z.number() })
});

/**
 * Infer TypeScript type from schema
 */
export type EditCustomerArgs = z.infer<typeof editCustomerArgsSchema>;
